import { useLocale } from '@/contexts/LocaleContext';
import { getTranslation } from '@/lib/translations';

// Custom hook for translations
export const useTranslation = () => {
  const { language } = useLocale();

  const t = (section, key) => {
    return getTranslation(section, key, language);
  };

  return { t, language };
};

// HOC for class components (if needed)
export const withTranslation = (Component) => {
  return function WrappedComponent(props) {
    const { t, language } = useTranslation();
    return <Component {...props} t={t} language={language} />;
  };
};

export default useTranslation;
